import { SigningCosmWasmClient } from "cosmwasm/build/cosmwasm-stargate";
import { comdex } from '../config/network'
import { KeplrWallet, contractAddr } from "./keplr";

const customFees = {
    upload: {
        amount: [{ amount: "2000000", denom: "ucmdx" }],
        gas: "2000000",
    },
    init: {
        amount: [{ amount: "500000", denom: "ucmdx" }],
        gas: "500000",
    },
    exec: {
        amount: [{ amount: "500000", denom: "ucmdx" }],
        gas: "500000",
    },
    send: {
        amount: [{ amount: "80000", denom: "ucmdx" }],
        gas: "80000",
    },
}

// const walletAddress = localStorage.getItem("ac");
function getTodayDate() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    var d = today.getDate()
    today = mm + '-' + dd + '-' + yyyy;

    return today;
}


const initializeTransaction = async (currentModule, currentVideo, callback) => {


    const httpUrl = comdex?.rpc;
    const walletAddress = localStorage.getItem("ac");
    const handleMsg = {
        "update_progress":
        {
            "module": currentModule,
            "video_completed": currentVideo,
            "date_completed": getTodayDate()
        }
    };

    const [offlineSigner, accounts] = await KeplrWallet(comdex?.chainId);

    const accountFromSigner = (await offlineSigner.getAccounts()).find(
        (account) => account.address === walletAddress,
    );

    await SigningCosmWasmClient.connectWithSigner(
        httpUrl,
        offlineSigner)
        .then((client) => {
            client.signAndBroadcast(
                walletAddress,
                [{
                    typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
                    value: {
                        sender: walletAddress,
                        contract: contractAddr,
                        msg: new TextEncoder().encode(JSON.stringify(handleMsg))
                    }
                }],
                customFees.exec
            ).then((response) => {
                callback(null, response)
                // console.log(response)

            }).catch((err) => {
                callback(err)
                console.log("err", err);
            })
        }).catch((error) => {
            callback(error)
            console.log("error", error)
        });

}

export const mintNftTransaction = async (currentModule, currentModuleName, callback) => {


    const httpUrl = comdex?.rpc;
    const walletAddress = localStorage.getItem("ac");
    const handleMsg = {
        "mint":
        {
            "owner": localStorage.getItem("ac"),
            "module_completed": currentModuleName,
            "date_completed": getTodayDate(),
            "module": currentModule,
        }
    };

    const [offlineSigner, accounts] = await KeplrWallet(comdex?.chainId);

    const accountFromSigner = (await offlineSigner.getAccounts()).find(
        (account) => account.address === walletAddress,
    );

    await SigningCosmWasmClient.connectWithSigner(
        httpUrl,
        offlineSigner)
        .then((client) => {
            client.signAndBroadcast(
                walletAddress,
                [{
                    typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
                    value: {
                        sender: walletAddress,
                        contract: contractAddr,
                        msg: new TextEncoder().encode(JSON.stringify(handleMsg))
                    }
                }],
                customFees.exec
            ).then((response) => {
                // console.log(response)
                callback(null, response)

            }).catch((err) => {
                console.log("err", err);
                callback(err)
            })
        }).catch((error) => {
            console.log("error", error)
            callback(error)

        });

}

export default initializeTransaction;